import axios from "axios";

export const state = {
    busaries: [],
};

export const getters = {
    busaries: state => state.busaries,
};

export const mutations = {
    setBusaries(state, newValue) {
        state.busaries = newValue
    },
};

export const actions = {
    fetchBusaries({ commit }) {
        axios.get('/busaries').then(res => {
            commit('setBusaries', res.data.bursaries);
        })
    },
};
